import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Page from 'src/components/Page'
import {
  Typography, Box, Container, CssBaseline,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
// import PropTypes from 'prop-types'
import SendUserStep from './SendUserStep'
import SendCodeStep from './SendCodeStep'
import styles from './ResetPassword.module.css'

const useStyles = makeStyles((theme) => ({
  root: {
    // display: 'flex',
    // height: '100vh',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(10, 7),
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  title: {
    marginBottom: theme.spacing(3),
    textAlign: 'center',
    fontSize: '24px',
    fontWeight: 'normal',
    color: '#000000',
  },
  image: {
    backgroundImage: 'url(images/login.jpg)',
    backgroundSize: '90%',
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundPosition: 'center 25%',
  },
  loginContainer: {
    width: '75%',
    '@media (max-width: 960px)': {
      width: '100%',
    },
    '@media (min-width: 1200px)': {
      width: '60%',
    },
  },
}))

// const steps = {
//   [SendUserStep.name]: SendUserStep,
//   [SendCodeStep.name]: SendCodeStep,
// }

const ResetPasswordStepper = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const [
    activeStep,
    setActiveStep,
  ] = useState('SendUserStep')

  // const CurrentComponent = steps[activeStep]
  return (
    <Page className={classes.root} title={`${t('reset')} ${t('password')}`}>

      <Box
        className={styles.main_login}
      >
        <CssBaseline />
        <Box
          className={styles.login_image_warp}
          style={{ height: '100%' }}
        >
          <img
            style={{ height: '100%' }}
            src="images/login.jpg"
            className={styles.new_login_image}
            alt="Login"
          />
        </Box>
        <Box className={styles.new_login_form_section}>
          <Box className={styles.new_login_form_section_box}>
            <img src="images/logo.svg" alt="logo" className={styles.login_logo} />
            <Typography classes={{ root: classes.title }} variant="h2">{`${t('reset')} ${t('password')}`}</Typography>
            <Container className={styles.loginContainer}>
              {/* <CurrentComponent setActiveStep={setActiveStep} /> */}
              {activeStep === 'SendUserStep' ? <SendUserStep setActiveStep={setActiveStep} />
                : <SendCodeStep setActiveStep={setActiveStep} />}
            </Container>
          </Box>
        </Box>
      </Box>
    </Page>
  )
}

ResetPasswordStepper.propTypes = {
}

export default ResetPasswordStepper
